import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='footer'>
       <div className="fLists">
            <ul className="fList">
                <li className="fListItem"><a href="/">Countries</a></li>
                <li className="fListItem"><a href="/">Regions</a></li>
                <li className="fListItem"><a href="/">Cities</a></li>
                <li className="fListItem"><a href="/">Districts</a></li>
                <li className="fListItem"><a href="/">Airports</a></li>
                <li className="fListItem"><a href="/">Hotels</a></li>
                <li className="fListItem"><a href="/">Places of interest</a></li>
            </ul>
            <ul className="fList">
                <li className="fListItem"><a href="/">Homes</a></li>
                <li className="fListItem"><a href="/">Apartments</a></li>
                <li className="fListItem"><a href="/">Resorts</a></li>
                <li className="fListItem"><a href="/">Villas</a></li>
                <li className="fListItem"><a href="/">Hostels</a></li>
                <li className="fListItem"><a href="/">B&Bs</a></li>
                <li className="fListItem"><a href="/">Guest houses</a></li>
            </ul>
            <ul className="fList">
                <li className="fListItem"><a href="/">Unique places to stay</a></li>
                <li className="fListItem"><a href="/">All destinations</a></li>
                <li className="fListItem"><a href="/">All flight destinations</a></li>
                <li className="fListItem"><a href="/">Discover</a></li>
                <li className="fListItem"><a href="/">Reviews</a></li>
                <li className="fListItem"><a href="/">Unpacked: Travel articles</a></li>
                <li className="fListItem"><a href="/">Travel Communities</a></li>
                <li className="fListItem"><a href="/">Seasonal and holiday deals</a></li>
            </ul>
            <ul className="fList">
                <li className="fListItem"><a href="/">Car hire</a></li>
                <li className="fListItem"><a href="/">Flight finder</a></li>
                <li className="fListItem"><a href="/">Restaurant reservaions</a></li>
                <li className="fListItem"><a href="/">Booknow.com for Travel Agents</a></li>
                
            </ul>
            <ul className="fList">
                <li className="fListItem"><a href="/">FAQs</a></li>
                <li className="fListItem"><a href="/">About Booknow.com</a></li>
                <li className="fListItem"><a href="/">Customer service</a></li>
                <li className="fListItem"><a href="/">Partner help</a></li>
                <li className="fListItem"><a href="/">Careers</a></li>
                <li className="fListItem"><a href="/">Sustainability</a></li>
                <li className="fListItem"><a href="/">Press centre</a></li>
                <li className="fListItem"><a href="/">Safety resource centre</a></li>
                <li className="fListItem"><a href="/">Investor relations</a></li>
                <li className="fListItem"><a href="/">Terms & conditions</a></li>
                <li className="fListItem"><a href="/">Dispute</a></li>
                <li className="fListItem"><a href="/">How we work</a></li>
                <li className="fListItem"><a href="/">Privacy & cookie statement</a></li>
                <li className="fListItem"><a href="/">MSA Statement</a></li>
                <li className="fListItem"><a href="/">Corporate contact</a></li>
            </ul>
       </div>
       <div className="fText"><p>Copyright © 2022 Booknow.com</p></div>
    </div>
  )
}

export default Footer